import { groupBy, identity, keyBy, keys, map, mapValues, sortBy } from 'lodash/fp';
import { SalesChartData } from '../../../../generated/graphql';

export const generateChartData = (salesChart: SalesChartData[]) => {
    const grouped = groupBy('date', salesChart);
    const dates = keys(grouped);
    const orderedKeys = sortBy(identity, dates);
    const groupedKeyed = mapValues(keyBy<SalesChartData>('paymentMethod'), grouped);

    const chartData = map(key => {
        const { Cash, CreditCard, Other } = groupedKeyed[key];
        const cash = Cash && Cash.income ? Cash.income : 0;
        const creditCard = CreditCard && CreditCard.income ? CreditCard.income : 0;
        const other = Other && Other.income ? Other.income : 0;
        const total = cash + creditCard + other;
        return {
            date: parseInt(key, 10),
            total,
            creditCard,
            cash,
            other,
        };
    }, orderedKeys);
    return chartData;
};
